<!-- 修改供应链主体 -->
<template>
  <div class="editSupplyChain main-content">
    <!-- 按钮 -->
    <div style="padding: 20px 0px">
      <el-button
        v-hasPermi="['2021050815390958955']"
        @click="handleEdit"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.seeOrEdit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815405934562']"
        @click="handleExport"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.export') }}</el-button
      >
    </div>
    <!-- 顶部菜单 -->
    <div class="topData">
      <el-form :model="topData" :rules="topDataRules" ref="topData" label-width="100px">
        <el-row :gutter="24">
          <!-- 公司code -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyCode')" prop="companyCode">
              <el-input disabled v-model="topData.companyCode"></el-input>
            </el-form-item>
          </el-col>
          <!-- 公司名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyName')" prop="companyName">
              <el-input disabled v-model="topData.companyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 业务部门 :disabled="forbidden"-->
            <el-form-item :label="$t('cooperation.label.departmentCode')" prop="departmentCode">
              <el-select
                @change="departmentChange"
                disabled
                v-model="topData.departmentCode"
                clearable
                filterable
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.personDepartmentCode"
                  :label="item.personDepartmentName"
                  :value="item.personDepartmentCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 申请时间 -->
            <el-form-item :label="$t('cooperation.label.requestTime')" prop="requestTime">
              <el-input disabled v-model="topData.requestTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 供应链主体编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('supplyChain.label.supplierCode')" prop="supplierCode">
              <el-input disabled v-model="topData.supplierCode"></el-input>
            </el-form-item>
          </el-col>
          <!-- 供应链主体名称 -->
          <el-col :span="6">
            <!-- 中文名 -->
            <!-- <el-form-item class="textOver" :label="$t('supplyChain.label.supplierName')" prop="supplierName">
                  <el-input disabled v-model="topData.supplierName"></el-input>
                </el-form-item> -->
            <el-tooltip
              :disabled="!topData.supplierName"
              class="item"
              effect="dark"
              :content="String(topData.supplierName)"
              placement="top"
            >
              <el-form-item
                class="textOver"
                :label="$t('supplyChain.label.supplierName')"
                prop="supplierName"
              >
                <el-input disabled v-model="topData.supplierName" v-if="forbidden"></el-input>
                <el-input
                  v-else
                  :disabled="disables"
                  v-model="topData.supplierName"
                  :placeholder="$t('cooperation.placeholder.zh')"
                  @change="searchPartner(topData.supplierName)"
                  clearable
                  maxlength="32"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="12">
            <!-- 英文名 -->
            <el-tooltip
              :disabled="!topData.partnerEnName"
              class="item"
              effect="dark"
              :content="String(topData.partnerEnName)"
              placement="top"
            >
              <!-- <el-form-item class="isShowLabel" prop="partnerEnName">
              <el-input disabled v-model="topData.partnerEnName"></el-input>
            </el-form-item> -->
              <el-form-item :label="$t('cooperation.label.partnerEnName')" prop="partnerEnName">
                <el-input disabled v-model="topData.partnerEnName" v-if="forbidden"></el-input>
                <el-input
                  disabled
                  v-else
                  :placeholder="$t('cooperation.placeholder.en')"
                  v-model="topData.partnerEnName"
                  clearable
                  maxlength="32"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 创建人 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.createBy')" prop="requestCreatePersonNo">
              <el-select disabled v-model="topData.requestCreatePersonNo" filterable>
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 申请人 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.requestBy')" prop="extendRequestPersonNo">
              <!-- <el-select clearable filterable v-model="topData.extendRequestPersonNo">
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id">
                </el-option>
              </el-select> -->
              <search-table
                :disabled="forbidden"
                v-model="topData.extendRequestPersonNo"
                searchType="personnel"
                :isMultiple="true"
                :currentValue="topData.extendRequestPersonName || null"
                :checkRowKeys="[topData.extendRequestPersonNo]"
                @input="setRequestPerson"
              ></search-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs type="border-card" v-model="activeNameTab">
      <!-- 基本数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.baseData')" name="baseData">
        <div class="baseData">
          <el-form disabled :model="baseData" ref="baseData" label-width="105px">
            <el-row :gutter="24">
              <!-- 统一社会信用代码 -->
              <el-col :span="6">
                <el-form-item
                  class="textOver"
                  :label="$t('cooperation.label.creditCode')"
                  prop="creditCode"
                >
                  <el-input v-model="baseData.creditCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 法人 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.legalPerson')" prop="legalPerson">
                  <el-input v-model="baseData.legalPerson" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 搜索简码 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.searchCode')" prop="searchCode">
                  <el-input v-model="baseData.searchCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 成立日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.establishedDate')"
                  prop="establishedDate"
                >
                  <el-date-picker
                    v-model="baseData.establishedDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 开票地址 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoiceAddress')" prop="invoiceAddress">
                  <el-input v-model="baseData.invoiceAddress" clearable maxlength="64"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票电话 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoicePhone')" prop="invoicePhone">
                  <el-input v-model="baseData.invoicePhone" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行名称 -->
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankName')"
                  prop="invoiceBankName"
                >
                  <el-input v-model="baseData.invoiceBankName" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行账号 -->
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankAccount')"
                  prop="invoiceBankAccount"
                >
                  <el-input
                    v-model="baseData.invoiceBankAccount"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 发票类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxType')" prop="taxType">
                  <el-select v-model="baseData.taxType" clearable filterable>
                    <el-option
                      v-for="item of taxTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 注册资本 -->
              <el-col :span="6">
                <el-row :gutter="24">
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('cooperation.label.registeredAssets')"
                      prop="registeredAssets"
                    >
                      <el-input
                        v-model="baseData.registeredAssets"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="currencyType">
                      <el-select
                        filterable
                        v-model="baseData.currencyType"
                        :placeholder="$t('cooperation.placeholder.currencyType')"
                        clearable
                      >
                        <el-option
                          v-for="item of tradeCurrencylist"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 交易币种 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.tradeCurrency')" prop="tradeCurrency">
                  <el-select v-model="baseData.tradeCurrency" clearable filterable>
                    <el-option
                      v-for="item of tradeCurrencylist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 企业类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.enterpriseType')" prop="enterpriseType">
                  <el-select v-model="baseData.enterpriseType" clearable filterable>
                    <el-option
                      v-for="item of enterpriseTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 省份/城市 -->
              <el-col :span="6">
                <el-row :gutter="24">
                  <el-col :span="16" style="padding-right: 0">
                    <el-form-item :label="$t('cooperation.label.province')" prop="province">
                      <el-select
                        v-model="baseData.province"
                        @change="changeProvince"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item of provinceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="city">
                      <el-select v-model="baseData.city" clearable filterable>
                        <el-option
                          v-for="item of cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 街道地址/门牌号 -->
              <el-col :span="12">
                <el-row :gutter="24">
                  <el-col :span="20" style="padding-right: 0">
                    <el-form-item
                      :label="$t('cooperation.label.streetAddress')"
                      prop="streetAddress"
                    >
                      <el-input
                        v-model="baseData.streetAddress"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item class="isShowLabel" prop="roomNo">
                      <el-input v-model="baseData.roomNo" clearable maxlength="32"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.postCode')" prop="postCode">
                  <el-input v-model="baseData.postCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 备注 -->
              <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                <el-input v-model="baseData.mark" clearable maxlength="80"></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <!-- 银行数据表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="banks"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.banks"
            :columns="bankColumnList"
            :edit-rules="bankTableEditRules"
            :valid-config="{ message: 'none' }"
            :toolbar="{}"
            :edit-config="forbidden ? {} : { trigger: 'click', mode: 'row' }"
          >
            <template v-if="!forbidden" v-slot:buttons>
              <vxe-button
                @click="$refs.banks.commitProxy('insert_actived')"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('banks')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
              <vxe-button @click="handleValidBank('ZT06')" type="primary" class="vxe-btn-primary">{{
                $t('cooperation.buttons.save')
              }}</vxe-button>
            </template>
          </vxe-grid>
        </div>
        <!-- 联系人表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="contactPersons"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.contactPersons"
            :columns="linkColumnList"
            :toolbar="{}"
            :edit-rules="linkTableEditRules"
            :valid-config="{ message: 'none' }"
            :edit-config="forbidden ? {} : { trigger: 'click', mode: 'row' }"
          >
            <template v-if="!forbidden" v-slot:buttons>
              <vxe-button
                @click="$refs.contactPersons.commitProxy('insert_actived')"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('contactPersons')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
              <vxe-button
                @click="handleValidPersons('ZT06')"
                type="primary"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.save') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
        <!-- 上传附件表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="attachments"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.attachments"
            :columns="fileColumnList"
            :toolbar="{}"
            @cell-dblclick="ossClick"
          >
            <template v-if="!forbidden" v-slot:buttons>
              <vxe-button
                @click="handleImportFile"
                type="primary"
                icon="el-icon-upload"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.importFile') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('attachments')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
              <vxe-button
                @click="handleSaveUpload('ZT06')"
                type="primary"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.save') }}</vxe-button
              >
            </template>
            <template v-else v-slot:buttons>
              <vxe-button
                size="medium"
                type="primary"
                class="vxe-btn-primary"
                icon="el-icon-download"
                @click="downLoadSelected()"
                >{{ $t('upload.downLoadBtn') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
      <!-- 销售数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.salesData')" name="salesData">
        <sales-data
          ref="salesData"
          v-if="salesTableData"
          :forbidden="forbidden"
          :salesTableData="salesTableData"
        />
      </el-tab-pane>
      <!-- 销售数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.purchasingData')" name="purchasingData">
        <purchasing-data
          ref="purchasingData"
          v-if="purchasingTableData"
          :forbidden="forbidden"
          :purchasingTableData="purchasingTableData"
        />
      </el-tab-pane>
      <!-- 扩展信息 -->
      <el-tab-pane
        :label="$t('cooperation.tabsName.extendedInformation')"
        v-if="userInfo.adminFlag == 1"
      >
        <extended
          ref="extendedInformation"
          :isEdit="false"
          :tableData="supplyDetail.extendInfos || []"
          v-if="supplyDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <footer class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050815384808744']"
        class="fixed-bottom-btn"
        type="primary"
        v-show="!forbidden && supplyDetail.requestStatus != 'ZT03'"
        @click="handleValid('ZT06')"
        >{{ $t('cooperation.buttons.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815385735531']"
        class="fixed-bottom-btn"
        type="primary"
        v-show="!forbidden"
        @click="handleValid('ZT02')"
        >{{ $t('cooperation.buttons.submit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815411426891']"
        v-show="supplyDetail.requestStatus == 'ZT03'"
        class="fixed-bottom-btn"
        type="primary"
        @click="expand"
        >{{ $t('cooperation.buttons.expand') }}</el-button
      >
    </footer>
    <!-- 上传 -->
    <el-upload
      v-show="false"
      accept=".xls,.xlsx"
      :data="ossData"
      :show-file-list="false"
      :with-credentials="true"
      :action="ossUrl"
      :before-upload="ossBefore"
      :on-success="ossSuccess"
      :on-error="ossError"
    >
      <el-button ref="uploadBtn" size="small" type="primary">{{
        $t('cooperation.buttons.clickImport')
      }}</el-button>
    </el-upload>
    <partner-list
      ref="partnerList"
      @getPartner="getPartner"
      @clearSupplierName="clearSupplierName"
      @handleExtend="handleExtend"
    />
    <expand
      :extendRequestDepartmentList="departmentList"
      ref="expand"
      @deleteSupplierName="deleteSupplierName"
    />
  </div>
</template>

<script>
  import API from '@/api/masterData/supplyChain';
  import DataBaseAPI from '@/api/dataBase';
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  import { topDataRules } from './rules/rules';
  import { bankTableEditRules, linkTableEditRules } from './rules/tableRules.js';
  import salesData from './components/salesData';
  import partnerList from './dialog/partnerList';
  import Expand from './dialog/expand';
  import purchasingData from './components/purchasingData';
  import SearchTable from '@/components/form-item/search-table';
  import Extended from './components/extended'; // 扩展信息
  import baseUrl from '@/common/config';
  export default {
    name: 'editSupplyChain',
    components: { SearchTable, salesData, purchasingData, Extended, partnerList, Expand },
    computed: {
      bankColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'bankName',
            title: this.$t('cooperation.label.bankName'),
            showHeaderOverflow: true,
            editRender: { type: 'default', autofocus: '.my-input' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bank"
                    isMultiple={true}
                    currentValue={row['bankName']}
                    checkRowKeys={[row['bankName']]}
                    onInput={(val) => this.chooseTable(val, row, 'bankName')}
                  ></search-table>,
                ];
              },
            },
          },
          {
            field: 'bankCode',
            title: this.$t('cooperation.label.bankCode'),
          },
          {
            field: 'associatedLineNumber',
            title: this.$t('cooperation.label.associatedLineNumber'),
          },
          {
            field: 'accountBankBranch',
            title: this.$t('cooperation.label.accountBankBranch'),
          },
          {
            field: 'bankAccount',
            title: this.$t('cooperation.label.bankAccount'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'contactPersonName',
            title: this.$t('cooperation.label.contactPersonName'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mobilePhone',
            title: this.$t('cooperation.label.mobilePhone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'telephone',
            title: this.$t('cooperation.label.telephone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'faxNo',
            title: this.$t('cooperation.label.faxNo'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'email',
            title: this.$t('cooperation.label.email'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'address',
            title: this.$t('cooperation.label.address'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      fileColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { field: 'attachmentName', title: this.$t('cooperation.label.attachmentName') },
          { field: 'createBy', title: this.$t('upload.uploader') },
          { field: 'gmtCreate', title: this.$t('upload.uploadDate') },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 发票类型
        taxTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'tax_type').dictList;
          }
        },
        // 企业类型
        enterpriseTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'enterprise_type').dictList;
          }
        },
        // 邮政编码
        postCodeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'post_code').dictList;
          }
        },
        // 省份
        provinceList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'province').dictList;
          }
        },
        //是否
        yesnoList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'isAnotherPay').dictList;
          }
        },
      }),
      propData() {
        return JSON.parse(this.$route.query.propData);
      },
    },
    data() {
      let newDate = dateFormat(new Date());
      return {
        activeNameTab: 'baseData',
        todayDate: newDate, //上传附件日期
        forbidden: true, // 禁用
        departmentList: [], // 部门数据
        requestByList: [], // 人员数据
        tradeCurrencylist: [], // 交易币种数据
        cityList: [], // 城市数据
        topData: {
          companyCode: '', // 公司代码
          companyName: '', // 公司名称
          departmentCode: '', // 业务部门
          departmentName: '', //部门名称
          requestTime: '', // 申请时间
          supplierCode: '', // 供应链主体编码
          supplierName: '', // 供应链主体名称中文
          partnerEnName: '', // 供应链主体名称英文
          requestCreatePersonName: '', // 当前用户/创建人name
          requestCreatePersonNo: '', // 当前用户/创建人code
          extendRequestPersonNo: '', // 申请人code
          extendRequestPersonName: '', // 申请人code
        },
        baseData: {
          creditCode: '',
          legalPerson: '',
          establishedDate: '',
          invoiceAddress: '',
          invoicePhone: '',
          invoiceBankName: '',
          invoiceBankAccount: '',
          taxType: '', // 发票类型
          registeredAssets: '',
          currencyType: '',
          searchCode: '',
          tradeCurrency: '',
          enterpriseType: '', // 企业类型
          postCode: '', // 邮政编码
          province: '', // 省份
          city: '', // 城市
          streetAddress: '', // 街道地址
          roomNo: '', // 门牌号
          mark: '', // 备注
          banks: [], // 银行表格
          contactPersons: [], // 联系人表格
          attachments: [], // 附件表格
          partnerCode: '',
        },
        topDataRules: topDataRules,
        bankTableEditRules: bankTableEditRules, // 银行表格校验规则
        linkTableEditRules: linkTableEditRules, // 联系人校验规则
        ossUrl: '', // 附件上传地址
        ossData: {}, // 附件上传参数
        salesTableData: null, // 销售表格数据
        purchasingTableData: null, // 采购表格数据
        disables: true,
        supplyDetail: {},
      };
    },
    mounted() {
      this.getDictList();
      this.getOssUrl();
      this.getSupplyDetail(
        this.userInfo.companyCode,
        this.propData.departmentCode,
        this.propData.id
      );
    },
    methods: {
      // 扩展按钮点击事件
      expand() {
        let companyInfo = {
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          departmentName: this.topData.departmentName,
          departmentCode: this.topData.departmentCode,
        };
        let propsPartnerData = {
          id: this.propData.id,
          supplierCode: this.supplyDetail.supplierCode,
          supplierName: this.supplyDetail.supplierName,
        };
        this.$refs.expand.openDialog(propsPartnerData, '', companyInfo);
      },
      //批量下载
      downLoadSelected() {
        const selectedList = this.$refs['attachments'].getSelectRecords(); // 或许选中数据
        if (selectedList.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          selectedList.forEach((item) => {
            this.downloadFile(item.attachmentPath);
          });
        }
      },
      //多个文件下载
      downloadFile(url) {
        window.open(url, '_blank');
      },
      // 获取合作伙伴详情
      getPartner(value) {
        this.supplierValue = value;
        let params = {
          id: value.id,
        };
        this.$axios.get(API.GET_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            this.partnerDetail = res.data.data;
            const formList = ['baseData'];
            formList.forEach((el) => {
              Object.keys(this[el]).forEach((item) => {
                this[el][item] = res.data.data[item];
              });
            });
            this.baseData.banks = this.partnerDetail.partnersBanks;
            this.baseData.contactPersons = this.partnerDetail.partnersPersons;
            this.baseData.attachments = this.partnerDetail.partnersAttachments || [];
            this.topData.supplierName = res.data.data.partnerZhName;
            this.topData.partnerEnName = res.data.data.partnerEnName;
            this.baseData.enterpriseType = res.data.data.enterpriseType;
            this.baseData.partnerCode = this.partnerDetail.partnerCode;
            if (this.partnerDetail.province)
              this.handleChangeBaseData(this.partnerDetail.province, 'province');
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 取消扩展 => 删除名称
      deleteSupplierName() {
        this.topData.supplierName = '';
        this.topData.partnerEnName = '';
      },
      // 扩展
      handleExtend(data) {
        this.$confirmAction(this.$t('supplyChain.message.isExtend'), '')
          .then(() => {
            this.$refs.expand.openDialog(data[0]);
          })
          .catch(() => {
            this.deleteSupplierName();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      // 取消新增清空中文名称输入框
      clearSupplierName() {
        this.topData.supplierName = '';
      },
      // 查询合作伙伴
      searchPartner(e) {
        let params = {
          adminFlag: this.userInfo.adminFlag,
          createBy: this.userInfo.userCode,
          departmentCode: this.userInfo.departmentCode,
          partnerName: e,
          distinctFlag: true,
          requestStatus: 'ZT03', // 已生效
        };
        this.loading.startLoading;
        this.$axios.post(API.LIST_PARTNEREXTEND, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            if (res.data.data.length > 0) {
              this.$refs.partnerList.openDialog(res.data.data);
            } else {
              this.$refs.partnerList.handleClose();
              this.deleteSupplierName();
              this.$message({
                showClose: true,
                message: this.$t('supplyChain.message.noData'),
                type: 'error',
              });
            }
          }
        });
      },
      //获取值
      chooseTable(val, row) {
        row.bankName = val[0].bankName || '-';
        row.bankCode = val[0].bankCode || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.accountBankBranch = val[0].bankBranch || '-';
      },
      // 获取详情
      getSupplyDetail(companyCode, departmentCode, id) {
        let params = {
          tenantCode: this.userInfo.tenantCode,
          companyCode: companyCode,
          departmentCode: departmentCode,
          id: id,
        };
        this.$axios
          .get(API.GET_SUPPLIER_DETAIL, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.supplyDetail = res.data.data;
              this.supplyDetail.requestTime = dateFormat(this.supplyDetail.requestTime);
              this.supplyDetail.companyCode = this.supplyDetail.companyNo;
              this.supplyDetail.departmentCode = this.supplyDetail.departmentNo;
              this.supplyDetail.requestCreatePersonNo = Number(this.supplyDetail.createPersonNo);
              this.supplyDetail.extendRequestPersonNo = Number(this.supplyDetail.requestPersonNo);
              this.supplyDetail.extendRequestPersonName = this.supplyDetail.requestPersonName;
              this.supplyDetail.supplierName = this.supplyDetail.partner.partnerZhName;
              this.supplyDetail.partnerEnName = this.supplyDetail.partner.partnerEnName;
              // var arr = this.requestByList.filter(
              //   (item) => item.id == this.supplyDetail.requestPersonNo
              // );
              Object.keys(this.topData).forEach((item) => {
                this.topData[item] = this.supplyDetail[item];
              });
              Object.keys(this.baseData).forEach((item) => {
                this.baseData[item] = this.supplyDetail.partner[item];
              });
              this.baseData.mark = this.supplyDetail.mark;
              this.baseData.banks = this.supplyDetail.banks;
              this.baseData.contactPersons = this.supplyDetail.contactPersons;
              this.baseData.attachments = this.supplyDetail.attachments || [];
              this.baseData.partnerCode = this.supplyDetail.partnerCode;
              // this.baseData.attachments = this.supplyDetail.attachments;
              if (this.baseData.province) this.changeProvince();
              if (
                this.supplyDetail.requestStatus == 'ZT05' ||
                this.supplyDetail.requestStatus == 'ZT06'
              ) {
                this.disables = false;
              } else {
                this.disables = true;
              }
            } else {
              this.$alert(res.data.msg);
            }
          })
          .then(() => {
            // 查询销售数据
            let query = {
              supplierId: this.propData.id,
              dataType: '1',
            };
            this.$axios.get(API.LIST_SUPPLIER_PARTNERS, query).then((res) => {
              if (res.data.code === 0) {
                this.salesTableData = {};
                this.salesTableData.list = res.data.data;
                this.salesTableData.saleAccountGroup = this.supplyDetail.saleAccountGroup;
                this.salesTableData.saleReconciliationSubject =
                  this.supplyDetail.saleReconciliationSubject;
                this.salesTableData.saleReconciliationSubjectDesc =
                  this.supplyDetail.saleReconciliationSubjectDesc;
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .then(() => {
            // 查询采购数据
            let query = {
              supplierId: this.propData.id,
              dataType: '2',
            };
            this.$axios.get(API.LIST_SUPPLIER_PARTNERS, query).then((res) => {
              if (res.data.code === 0) {
                this.purchasingTableData = {};
                this.purchasingTableData.list = res.data.data;
                this.purchasingTableData.purchaseAccountGroup =
                  this.supplyDetail.purchaseAccountGroup;
                this.purchasingTableData.purchaseReconciliationSubject =
                  this.supplyDetail.purchaseReconciliationSubject;
                this.purchasingTableData.purchaseReconciliationSubjectDesc =
                  this.supplyDetail.purchaseReconciliationSubjectDesc;
              } else {
                this.$alert(res.data.msg);
              }
            });
          });
        this.activeNameTab = 'baseData';
      },
      // 部门切换
      departmentChange(value) {
        let params = {
          supplierCode: this.propData.supplierCode,
          departmentCode: value,
        };
        this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data.length > 0) {
              let data = res.data.data[0];
              this.getSupplyDetail(data.companyCode, data.departmentCode, data.id);
            } else {
              this.topData.departmentCode = this.propData.departmentCode;
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('supplyChain.message.theDepartmentNoData'),
              });
            }
          }
        });
      },
      // 修改/显示
      handleEdit() {
        this.forbidden = !this.forbidden;
      },
      // 导出详情
      handleExport() {
        this.$axios
          .get(API.EXPORT_SUPPLIERS_DETAIL, { id: this.supplyDetail.extendId })
          .then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            }
          });
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      // 保存
      handleValid(type) {
        // 顶部表单校验
        const topDataValid = new Promise((resolve, reject) => {
          this.$refs.topData.validate((valid) => {
            if (valid) {
              resolve(this.topData);
            } else {
              // toFormErrorTop();
              reject('topData');
            }
          });
        });
        // 银行表格校验
        const banks = new Promise((resolve, reject) => {
          this.$refs.banks.validate((valid) => {
            if (valid) {
              resolve(this.baseData.banks);
            } else {
              // toFormErrorTop();
              reject('banks');
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('supplyChain.message.perfectBank'),
              });
            }
          });
        });
        // 联系人表格校验
        const contactPersons = new Promise((resolve, reject) => {
          this.$refs.contactPersons.validate((valid) => {
            if (valid) {
              resolve(this.baseData.contactPersons);
            } else {
              // toFormErrorTop();
              reject('contactPersons');
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('supplyChain.message.perfectPerson'),
              });
            }
          });
        });
        const list = [
          topDataValid,
          banks,
          contactPersons,
          this.$refs.salesData.returnData(),
          this.$refs.purchasingData.returnData(),
        ];
        Promise.all(list)
          .then((result) => {
            // 校验通过
            this.handleSave(result, type);
          })
          .catch((err) => {
            if (err == 'baseData' || err == 'salesData' || err == 'purchasingData') {
              this.activeNameTab = err;
            } else {
              this.activeNameTab = 'baseData';
            }
            // toFormErrorTop();
          });
      },
      handleSave(result, type) {
        this.loading.startLoading();
        let params = Object.assign(result[0], this.baseData);
        params = Object.assign(params, result[3]);
        params = Object.assign(params, result[4]);
        params.adminFlag = this.userInfo.adminFlag;
        params.isSubmit = type == 'ZT06' ? '2' : '1';
        params.id = this.supplyDetail.extendId;
        params.supplierId = this.supplyDetail.supplierId;
        params.version = this.supplyDetail.version;
        params.partnerCode = this.baseData.partnerCode;
        params.tenantCode = this.userInfo.tenantCode;
        params.requestCreatePersonName = this.topData.requestCreatePersonName;
        params.supplierCompanyNo = params.companyCode;
        params.supplierCompanyName = params.companyName;
        params.extendRequestDepartmentNo = params.departmentCode;
        params.extendRequestDepartmentName = params.departmentName;
        params.banks = this.$refs.banks.getTableData().fullData;
        params.contactPersons = this.$refs.contactPersons.getTableData().fullData;
        params.attachments = this.$refs.attachments.getTableData().fullData;
        params.supplierPartners = [...params.customerList, ...params.serviceList];
        delete params.requestTime;
        params.isUpdate = true; // 修改标记
        this.$axios.post(API.ADD_SUPPLIER, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            if (type == 'ZT06') {
              this.getSupplyDetail(
                this.userInfo.companyCode,
                this.propData.departmentCode,
                this.propData.id
              );
            } else {
              let path = {
                fromPath: {
                  path: '/masterData/addSupplyChain',
                  name: 'addSupplyChain',
                  meta: {
                    keepAlive: true,
                    title: '',
                  },
                },
                toPath: {
                  path: '/masterData/supplyChain',
                  name: 'supplyChain',
                  meta: {
                    keepAlive: false,
                    title: this.$t('supplyChain.router.list'),
                  },
                },
              };
              this.$store.dispatch('tagsView/backTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path.toPath);
                });
              });
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //保存 银行
      handleValidBank(type) {
        // 银行表格校验
        const banks = new Promise((resolve, reject) => {
          this.$refs.banks
            .validate((valid) => {
              if (valid) {
                resolve(this.baseData.banks);
              } else {
                reject();
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: this.$t('supplyChain.message.perfectBank'),
                });
              }
            })
            .catch(() => {});
        });
        const list = [
          this.topData,
          banks,
          this.baseData.contactPersons,
          this.$refs.salesData.returnData(),
          this.$refs.purchasingData.returnData(),
        ];
        Promise.all(list).then((result) => {
          // 校验通过
          console.log('result: ', result);
          this.handleSaveOne(result, type);
        });
      },
      //保存 联系人
      handleValidPersons(type) {
        // 联系人表格校验
        const contactPersons = new Promise((resolve, reject) => {
          this.$refs.contactPersons.validate((valid) => {
            if (valid) {
              resolve(this.baseData.contactPersons);
            } else {
              reject();
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('supplyChain.message.perfectPerson'),
              });
            }
          });
        });
        const list = [
          this.topData,
          this.baseDatabanks,
          contactPersons,
          this.$refs.salesData.returnData(),
          this.$refs.purchasingData.returnData(),
        ];
        Promise.all(list).then((result) => {
          // 校验通过
          this.handleSaveOne(result, type);
        });
      },
      //附件
      handleSaveUpload(type) {
        const list = [
          this.topData,
          this.baseData.banks,
          this.baseData.contactPersons,
          this.$refs.salesData.returnData(),
          this.$refs.purchasingData.returnData(),
        ];
        //  this.baseData.attachments
        this.handleSaveOne(list, type);
      },
      handleSaveOne(result, type) {
        // this.loading.startLoading();
        let params = Object.assign(result[0], this.baseData);
        params = Object.assign(params, result[3]);
        params = Object.assign(params, result[4]);
        params.adminFlag = this.userInfo.adminFlag;
        params.isSubmit = type == 'ZT06' ? '2' : '1';
        params.id = this.supplyDetail.extendId;
        params.supplierId = this.supplyDetail.supplierId;
        params.version = this.supplyDetail.version;
        params.partnerCode = this.baseData.partnerCode;
        params.tenantCode = this.userInfo.tenantCode;
        params.requestCreatePersonName = this.topData.requestCreatePersonName;
        params.supplierCompanyNo = params.companyCode;
        params.supplierCompanyName = params.companyName;
        params.extendRequestDepartmentNo = params.departmentCode;
        params.extendRequestDepartmentName = params.departmentName;
        params.banks = this.$refs.banks.getTableData().fullData;
        params.contactPersons = this.$refs.contactPersons.getTableData().fullData;
        params.attachments = this.$refs.attachments.getTableData().fullData;
        params.supplierPartners = [];
        console.log(' params.supplierPartners: ', params.supplierPartners);
        delete params.requestTime;
        params.isUpdate = true; // 修改标记
        console.log(params);
        this.$axios.post(API.B_P_SAVE, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //申请人
      setRequestPerson(row) {
        this.topData.extendRequestPersonNo = row ? row[0].id : null;
        this.topData.extendRequestPersonName = row ? row[0].personName : null;
      },
      // 导入文件
      handleImportFile() {
        this.$refs.uploadBtn.$el.click();
      },
      // 获取附件上传地址
      getOssUrl() {
        this.ossUrl = baseUrl + API.OSS_UPLOAD_API;
        // 附件上传参数
        this.ossData = {
          tenantCode: this.userInfo.tenantCode,
          access_token: this.userInfo.access_token,
        };
      },
      // 开始上传
      ossBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      ossSuccess(response, file) {
        this.loading.endLoading();
        if (response.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t('bank.message.importSuccess'),
            type: 'success',
          });
          let fileObj = {
            attachmentName: file.name,
            attachmentPath: file.response.data,
            createBy: this.userInfo.userName,
            gmtCreate: this.todayDate,
          };
          this.baseData.attachments.push(fileObj);
        } else {
          if (response.data) {
            window.location.href = `${response.data}`;
          }
          this.$message({ showClose: true, message: response.msg, type: 'error' });
        }
      },
      // 上传错误
      ossError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 附件双击下载
      ossClick(data) {
        window.location.href = data.row.attachmentPath;
      },
      getDictList() {
        // const tenantCode = this.userInfo.tenantCode;
        // 获取部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          }
        });
        // 获取用户数据
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            this.requestByList = res.data.data.personInfo;
          }
        });

        this.$baseRequest.getCurrency().then((res) => {
          this.tradeCurrencylist = [];
          if (res.length > 0) {
            res.map((item) => {
              item['value'] = item.currencyCode;
              item['label'] = item.currencyName;
              this.tradeCurrencylist.push(item);
            });
          }
        });
      },
      // 城市
      changeProvince(value) {
        this.baseData.city = !value ? this.baseData.city : '';
        value = value || this.baseData.province;
        this.$axios.post(DataBaseAPI.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
    },
  };
</script>

<style>
  .editSupplyChain .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
  .editSupplyChain .textOver label {
    line-height: unset;
  }
  .editSupplyChain .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped>
  .editSupplyChain {
    padding-bottom: 100px;
  }
  .editSupplyChain .el-select,
  .el-input {
    width: 100%;
  }
</style>
